const PATTERN_CHARACTERS = /[.*+?^${}()|[\]\\]/g
const WORD_CHARACTER = '[\\p{L}\\p{N}]'

const escapePattern = term => term.replace(PATTERN_CHARACTERS, '\\$&')

const usableTerms = terms =>
  [...new Set((terms ?? []).map(term => (term ?? '').trim()).filter(Boolean))].sort((a, b) => b.length - a.length)

export const highlightParts = (text, terms) => {
  if (!text) return []
  const wanted = usableTerms(terms)
  if (!wanted.length) return [{ text, strong: false }]
  const alternatives = wanted.map(escapePattern).join('|')
  const pattern = new RegExp(`(?<!${WORD_CHARACTER})(${alternatives})(?!${WORD_CHARACTER})`, 'gu')
  return text
    .split(pattern)
    .map((part, index) => ({ text: part, strong: index % 2 === 1 }))
    .filter(part => part.text)
}
